import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#2c2c2c', // Dark Gray
    },
    secondary: {
      main: '#4db6ac', // Teal
    },
    error: {
      main: red.A400, // A slightly darker red for better contrast
    },
    background: {
      default: '#f7f9fa', // A very light, clean gray
      paper: '#ffffff',
    },
    text: {
      primary: '#444746',
      secondary: '#6c757d',
    },
    overage: {
      main: '#FF6961',
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
        fontSize: '1.5rem',
        fontWeight: 500,
    },
    h5: {
        fontSize: '1.25rem',
        fontWeight: 500,
    },
    h6: {
        fontSize: '1rem',
        fontWeight: 500,
    }
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiAppBar: {
        styleOverrides: {
            root: {
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
            }
        }
    }
  },
});

export default theme;
